import {typePack} from './typePack';
import {domain} from './domain';
import {country} from './country';

export const packCountryDomain = function (item = null) {
    return {
        id: item == null ? null : item.id,
        price: item == null ? 0 : item.price,
        technicalSupport: item == null ? 0 : item.technicalSupport,
        numberOfUsers: item == null ? 0 : item.numberOfUsers,
        isFree: item == null ? false : item.isFree,
        isUnlimited: item == null ? false : item.subscriptionPeriod == -1,
        isActive: item == null ? false : item.isActive,
        freePeriod: item == null ? 0 : item.freePeriod,
        subscriptionPeriod: item == null ? 0 : item.subscriptionPeriod,
        country: country(item == null ? null : item.country),
        typePack: typePack(item == null ? null : item.typePack),
        domain: domain(item == null ? null : item.domain),
        isWithTecDoc: !(item == null||item.isWithTecDoc == 0),
        isLight: item == null || item.isLight == undefined ? false : item.isLight,


    };
};
